import type { IApiErrorPlain, IProblem } from '@platform/core/types';

/** Помилка API з ProblemDetails; серіалізується у стан RTK Query без втрати коду та полів валідації. */
export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly errors: Record<string, string[]>;

  constructor(status: number, problem: IProblem | null, fallback: string) {
    super(problem?.title ?? problem?.detail ?? fallback);
    this.name = 'ApiError';
    this.status = status;
    this.code = problem?.code ?? (status === 0 ? 'network' : 'http_' + status);
    this.errors = problem?.errors ?? {};
  }

  /** Серіалізована форма для RTK Query (error має бути простим об'єктом). */
  toPlain(): IApiErrorPlain {
    return { status: this.status, code: this.code, message: this.message, errors: this.errors };
  }

  static fromUnknown(e: unknown): IApiErrorPlain {
    if (e instanceof ApiError) return e.toPlain();
    return { status: 0, code: 'network', message: e instanceof Error ? e.message : String(e), errors: {} };
  }
}
